// extracted by mini-css-extract-plugin
export default {"wrapper":"qp","form":"rp","preference":"sp","request":"tp","job":"up","smallprint":"vp","asterisk":"wp","success":"xp","circle":"yp"};